(() => {
  function encodeProperties(properties) {
    const json = JSON.stringify(properties);
    const bytes = new TextEncoder().encode(json);

    let binary = '';

    bytes.forEach((byte) => {
      binary += String.fromCharCode(byte);
    });

    return btoa(binary)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/g, '');
  }

  function findProductForm(button) {
    const component = button.closest(
      'product-form-component'
    );

    if (component) {
      const form = component.querySelector(
        'form[data-type="add-to-cart-form"]'
      );

      if (form) {
        return form;
      }
    }

    /*
     * Respaldo específico para Agregado rápido.
     */
    const quickAdd = button.closest(
      '#quick-add-modal-content'
    );

    if (quickAdd) {
      return quickAdd.querySelector(
        'form[data-type="add-to-cart-form"]'
      );
    }

    return null;
  }

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest(
        '[data-m90-buy-now]'
      );

      if (!button) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (button.dataset.m90Busy === 'true') {
        return;
      }

      const form = findProductForm(button);

      if (!form) {
        console.error(
          'M90: no se encontró el formulario del producto.'
        );
        return;
      }

      /*
       * Valida el dorsal y cualquier otro
       * campo obligatorio antes de continuar.
       */
      if (!form.reportValidity()) {
        return;
      }

      const variantInput = form.querySelector(
        'input[name="id"]'
      );

      const variantId =
        variantInput?.value?.trim();

      if (!variantId) {
        console.error(
          'M90: no se encontró la variante seleccionada.'
        );
        return;
      }

      /*
       * Cantidad.
       */
      const quantityInput = form.querySelector(
        'input[name="quantity"]'
      );

      const quantity = Math.max(
        1,
        parseInt(
          quantityInput?.value || '1',
          10
        ) || 1
      );

      /*
       * Propiedades personalizadas:
       * Nombre y número, etc.
       */
      const properties = {};

      form
        .querySelectorAll(
          '[name^="properties["]'
        )
        .forEach((input) => {
          if (
            input.disabled ||
            (
              (input.type === 'checkbox' ||
               input.type === 'radio') &&
              !input.checked
            )
          ) {
            return;
          }

          const match = input.name.match(
            /^properties\[(.+)\]$/
          );

          if (!match) {
            return;
          }

          const value =
            String(input.value || '').trim();

          if (value) {
            properties[match[1]] = value;
          }
        });

      /*
       * Enlace directo al checkout.
       */
      let checkoutUrl =
        `/cart/${variantId}:${quantity}`;

      if (
        Object.keys(properties).length > 0
      ) {
        checkoutUrl +=
          `?properties=${encodeURIComponent(
            encodeProperties(properties)
          )}`;
      }

      button.dataset.m90Busy = 'true';

      window.location.assign(checkoutUrl);
    },
    true
  );
})();